import { render } from "./manage-customer.vue?vue&type=template&id=2cadd61b"
import script from "./manage-customer.vue?vue&type=script&lang=js"
export * from "./manage-customer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__